import { websiteBuilderGenerateDefaultHeading } from "../../element/websiteBuilderHeading";
import { WEBSITE_BUILDER_TEMPLATE_ICON_ASSET_IDENTITIES, websiteBuilderGenerateDefaultIcon, websiteBuilderResolveIconAssetIdentity } from "../../element/websiteBuilderIcon";
import { websiteBuilderGenerateDefaultParagraph } from "../../element/websiteBuilderParagraph";
import { IWebsiteBuilderIconAsset, IWebsiteBuilderMediaItem } from "redux/reducers/models/websiteBuilder";
import { IWebsiteBuilderContent, websiteBuilderGenerateDefaultContent } from "../websiteBuilderContent";
import { websiteBuilderGenerateTemplateImage } from "./websiteBuilderResolveTemplateMedia";

export function websiteBuilderContactTemplate(
  media: IWebsiteBuilderMediaItem[],
  iconAssets: IWebsiteBuilderIconAsset[],
): IWebsiteBuilderContent {
  const section = websiteBuilderGenerateDefaultContent();
  const heading = websiteBuilderGenerateDefaultHeading();
  const description = websiteBuilderGenerateDefaultParagraph();
  const address = websiteBuilderGenerateDefaultParagraph();
  const city = websiteBuilderGenerateDefaultParagraph();
  const businessHours = websiteBuilderGenerateDefaultParagraph();
  const phoneNumber = websiteBuilderGenerateDefaultParagraph();
  const facebookIcon = websiteBuilderGenerateDefaultIcon(
    websiteBuilderResolveIconAssetIdentity(iconAssets, WEBSITE_BUILDER_TEMPLATE_ICON_ASSET_IDENTITIES.facebookLogo),
  );
  const instagramIcon = websiteBuilderGenerateDefaultIcon(
    websiteBuilderResolveIconAssetIdentity(iconAssets, WEBSITE_BUILDER_TEMPLATE_ICON_ASSET_IDENTITIES.instagramLogo),
  );
  const twitterIcon = websiteBuilderGenerateDefaultIcon(
    websiteBuilderResolveIconAssetIdentity(iconAssets, WEBSITE_BUILDER_TEMPLATE_ICON_ASSET_IDENTITIES.twitterLogo),
  );
  const image = websiteBuilderGenerateTemplateImage(media, "aerial-golf-course");

  section.section.background.color = "#2B4212";

  section.section.layout.desktop.height = 900;
  section.section.layout.tablet.height = 800;
  section.section.layout.mobile.height = 820;

  heading.element.layout.desktop.position = { x: 80, y: 80 };
  heading.element.layout.tablet.position = { x: 32, y: 60 };
  heading.element.layout.mobile.position = { x: 25, y: 40 };
  heading.element.layout.desktop.dimensions = { width: 500, height: 65 };
  heading.element.layout.tablet.dimensions = { width: 380, height: 55 };
  heading.element.layout.mobile.dimensions = { width: 270, height: 50 };
  heading.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "48px",
        tablet: "40px",
        mobile: "32px",
      },
    },
    content: [{
      type: "heading",
      attrs: { level: 1, lineHeight: "1.15" },
      content: [{
        type: "text",
        text: "Contact us", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#FFFFFF",
          },
        }],
      }],
    }],
  };

  description.element.layout.desktop.position = { x: 80, y: 155 };
  description.element.layout.tablet.position = { x: 32, y: 125 };
  description.element.layout.mobile.position = { x: 25, y: 105 };
  description.element.layout.desktop.dimensions = { width: 575, height: 60 };
  description.element.layout.tablet.dimensions = { width: 410, height: 80 };
  description.element.layout.mobile.dimensions = { width: 270, height: 80 };
  description.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "18px",
        tablet: "16px",
        mobile: "14px",
      },
    },
    content: [{
      type: "paragraph",
      attrs: { lineHeight: "1.4" },
      content: [{
        type: "text",
        text: "Stop by to explore our offerings, connect with our team and experience our place firsthand. We can't wait to welcome you!", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#FFFFFF",
          },
        }],
      }],
    }],
  };

  address.element.layout.desktop.position = { x: 715, y: 80 };
  address.element.layout.tablet.position = { x: 480, y: 60 };
  address.element.layout.mobile.position = { x: 25, y: 200 };
  address.element.layout.desktop.dimensions = { width: 160, height: 25 };
  address.element.layout.tablet.dimensions = { width: 170, height: 25 };
  address.element.layout.mobile.dimensions = { width: 270, height: 25 };
  address.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "16px",
        tablet: "15px",
        mobile: "14px",
      },
    },
    content: [{
      type: "paragraph",
      content: [{
        type: "text",
        text: "123 Example St.", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#FFFFFF",
          },
        }],
      }],
    }],
  };

  city.element.layout.desktop.position = { x: 715, y: 110 };
  city.element.layout.tablet.position = { x: 480, y: 90 };
  city.element.layout.mobile.position = { x: 25, y: 230 };
  city.element.layout.desktop.dimensions = { width: 160, height: 25 };
  city.element.layout.tablet.dimensions = { width: 170, height: 25 };
  city.element.layout.mobile.dimensions = { width: 270, height: 25 };
  city.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "16px",
        tablet: "15px",
        mobile: "14px",
      },
    },
    content: [{
      type: "paragraph",
      content: [{
        type: "text",
        text: "Kitchener, Canada", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#FFFFFF",
          },
        }],
      }],
    }],
  };

  businessHours.element.layout.desktop.position = { x: 715, y: 155 };
  businessHours.element.layout.tablet.position = { x: 480, y: 135 };
  businessHours.element.layout.mobile.position = { x: 25, y: 275 };
  businessHours.element.layout.desktop.dimensions = { width: 160, height: 50 };
  businessHours.element.layout.tablet.dimensions = { width: 170, height: 50 };
  businessHours.element.layout.mobile.dimensions = { width: 270, height: 25 };
  businessHours.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "16px",
        tablet: "15px",
        mobile: "14px",
      },
    },
    content: [{
      type: "paragraph",
      attrs: { lineHeight: "1.4" },
      content: [{
        type: "text",
        text: "Mon - Fri, 9AM - 5PM", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#FFFFFF",
          },
        }],
      }],
    }],
  };

  phoneNumber.element.layout.desktop.position = { x: 715, y: 215 };
  phoneNumber.element.layout.tablet.position = { x: 480, y: 195 };
  phoneNumber.element.layout.mobile.position = { x: 25, y: 310 };
  phoneNumber.element.layout.desktop.dimensions = { width: 160, height: 25 };
  phoneNumber.element.layout.tablet.dimensions = { width: 170, height: 25 };
  phoneNumber.element.layout.mobile.dimensions = { width: 270, height: 25 };
  phoneNumber.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "16px",
        tablet: "15px",
        mobile: "14px",
      },
    },
    content: [{
      type: "paragraph",
      content: [{
        type: "text",
        text: "(123) 456-7890",
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#FFFFFF",
          },
        }],
      }],
    }],
  };

  facebookIcon.element.layout.desktop.position = { x: 890, y: 80 };
  facebookIcon.element.layout.tablet.position = { x: 706, y: 60 };
  facebookIcon.element.layout.mobile.position = { x: 25, y: 350 };
  facebookIcon.element.layout.desktop.dimensions = { width: 30, height: 30 };
  facebookIcon.element.layout.tablet.dimensions = { width: 30, height: 30 };
  facebookIcon.element.layout.mobile.dimensions = { width: 30, height: 30 };
  facebookIcon.element.settings.color = "#FFFFFF";

  instagramIcon.element.layout.desktop.position = { x: 890, y: 145 };
  instagramIcon.element.layout.tablet.position = { x: 706, y: 125 };
  instagramIcon.element.layout.mobile.position = { x: 85, y: 350 };
  instagramIcon.element.layout.desktop.dimensions = { width: 30, height: 30 };
  instagramIcon.element.layout.tablet.dimensions = { width: 30, height: 30 };
  instagramIcon.element.layout.mobile.dimensions = { width: 30, height: 30 };
  instagramIcon.element.settings.color = "#FFFFFF";

  twitterIcon.element.layout.desktop.position = { x: 890, y: 210 };
  twitterIcon.element.layout.tablet.position = { x: 706, y: 190 };
  twitterIcon.element.layout.mobile.position = { x: 145, y: 350 };
  twitterIcon.element.layout.desktop.dimensions = { width: 30, height: 30 };
  twitterIcon.element.layout.tablet.dimensions = { width: 30, height: 30 };
  twitterIcon.element.layout.mobile.dimensions = { width: 30, height: 30 };
  twitterIcon.element.settings.color = "#FFFFFF";

  image.element.layout.desktop.position = { x: 80, y: 300 };
  image.element.layout.tablet.position = { x: 32, y: 270 };
  image.element.layout.mobile.position = { x: 25, y: 410 };
  image.element.layout.desktop.dimensions = { width: 840, height: 600 };
  image.element.layout.tablet.dimensions = { width: 704, height: 498 };
  image.element.layout.mobile.dimensions = { width: 270, height: 385 };
  image.element.settings.alt = "Aerial view of a golf course"; // TODO: Translation
  image.element.settings.borderRadius = 12;

  section.children = [
    heading,
    description,
    address,
    city,
    businessHours,
    phoneNumber,
    facebookIcon,
    instagramIcon,
    twitterIcon,
    image,
  ];

  return section;
}
